import React from 'react';
import RichLayout from '@components/_struct/_layouts/RichLayout';
import { useMSTranslation } from '@utils/useMSTranslation';
import Head from 'next/head';

const Cgu = () => {
    const { __ } = useMSTranslation(['cgu']);

    return (
        <RichLayout>
            <Head>
                <title>{__('CGU', 'cgu')} | Viseet.me</title>
            </Head>
            <h1>{__("Conditions Générales d'Utilisation", 'cgu')}</h1>
            <h2>
                {__(
                    'Conditions générales d’utilisation des logiciels en ligne développés par VISEET et des applications associées',
                    'cgu'
                )}
            </h2>
            <p>
                {__(
                    'Les présentes Conditions Générales d’Utilisation (ci-après « CGU ») régissent les rapports entre d’une part, la société VISEET, société par actions simplifiée, au capital de 256.413 euros, immatriculée au registre du commerce et des sociétés de Nanterre sous le numéro 897 655 643, dont le siège social est situé 59, rue de l’Ancienne Marie, 92100 Boulogne Billancourt (ci-après VISEET) et d’autre part, tout organisateur d’événement à visée professionnelle (ci-après l’ « Organisateur ») utilisant les logiciels en ligne développés par VISEET et les applications associées pour l’organisation de ses événements.',
                    'cgu'
                )}
            </p>
            <h2>{__('Définitions', 'cgu')}</h2>
            <p>
                {__(
                    'Dans les CGU, les termes et expressions identifiés par une majuscule ont la signification indiquée ci-après, qu’ils soient employés au singulier ou au pluriel.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    '« Evénements » : désigne les manifestations organisées par l’Organisateur sur la plateforme et auxquels participent les Invités ;',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    '« Invité » : désigne toute personne invitée par l’Organisateur à s’inscrire et participer à l’Evénement en utilisant le Service;',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    '« Organisateur » : désigne la personne morale organisant un Evénement, auquel elle invite des Invités en utilisant le Service;',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    '« Service » : désigne le logiciel en ligne de VISEET',
                    'cgu'
                )}
            </p>
            <h2>{__('Objet', 'cgu')}</h2>
            <p>
                {__(
                    "Les CGU ont pour objet de définir les conditions d'utilisation du Service. En utilisant le Service, l’Organisateur accepte de respecter et d’être lié par les CGU, ainsi que par l’annexe Données personnelles.",
                    'cgu'
                )}
            </p>
            <h2>{__('Description du Service', 'cgu')}</h2>
            <p>{__('Le Service permet à l’Organisateur :', 'cgu')}</p>
            <ul>
                <li>
                    {__(
                        'De gérer l’organisation de son Evénement via la plateforme',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'De créer un formulaire d’invitation et de sélectionner les invités',
                        'cgu'
                    )}
                </li>
                <li>{__('De créer plusieurs salons virtuels', 'cgu')}</li>
                <li>
                    {__(
                        'D’échanger avec les invités sur la plateforme via visioconférence',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'De retrouver les informations des invités pendant et après l’événement',
                        'cgu'
                    )}
                </li>
            </ul>
            <h2>{__('Inscription au Service', 'cgu')}</h2>
            <p>
                {__(
                    'Pour pouvoir accéder au Service, l’Organisateur doit bénéficier d’une connexion Internet et créer un compte en remplissant le formulaire d’inscription disponible en ligne et accepter les termes des présentes CGU.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'La validation électronique du formulaire d’inscription ou la signature d’un devis par le Client entraîne l’acceptation sans réserve des CGU.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'Lors de son inscription, l’Organisateur s’engage à fournir des informations complètes, exactes et à jour. Ces informations comprennent notamment la dénomination et la raison sociale de l’Organisateur, l’adresse postale de son siège social, le nom et l’adresse électronique de l’Organisateur. L’Organisateur s’engage à informer sans délai VISEET de toute modification concernant lesdites informations.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    "L'Organisateur s’engage à communiquer sans délai à VISEET toute modification de son nom ou de la raison sociale de la personne morale qu’il représente, de son domicile, du siège social de la personne morale qu’il représente, de son adresse de facturation, de la forme juridique de son entreprise, de ses coordonnées bancaires ou de son numéro de TVA intracommunautaire.",
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'La personne remplissant le formulaire d’inscription pour le compte de l’Organisateur certifie être parfaitement habilitée à représenter celui-ci, VISEET pouvant exiger de cette personne la présentation d’un pouvoir pour l’engager. L’Organisateur est une personne morale dûment enregistrée au registre du commerce et des sociétés, ne faisant l’objet d’aucune mesure de redressement judiciaire de liquidation ou de sauvegarde et ayant la pleine capacité de contracter.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'VISEET se réserve le droit de rejeter, de façon discrétionnaire, toute inscription.',
                    'cgu'
                )}
            </p>
            <h2>{__('Identifiants personnels et profil', 'cgu')}</h2>
            <p>
                {__(
                    'Une fois l’inscription finalisée, l’Organisateur reçoit un identifiant et un mot de passe. Ces identifiants sont strictement personnels et l’Organisateur s’engage à ne pas les divulguer. VISEET se réserve le droit de résilier tout compte dont elle aura raisonnablement établi que les identifiant et mot de passe pourraient avoir été utilisés par une personne non autorisée.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'L’Organisateur a également la possibilité de créer un profil contenant certaines données personnelles. Dans la mesure où ces données sont volontairement mises en ligne par l’Organisateur, ce dernier est dûment informé et accepte sans réserve que ces données personnelles soient conservées par VISEET.',
                    'cgu'
                )}
            </p>
            <h2>{__('Organisation d’Evénements', 'cgu')}</h2>
            <p>
                {__(
                    'L’Organisateur a la possibilité d’organiser plusieurs Evènements à partir d’un compte Organisateur unique. Toutefois, pour pouvoir profiter de l’ensemble des fonctionnalités et avantages du Service, l’Organisateur doit souscrire aux offres Packs disponibles en ligne sur le site de VISEET conformément à l’Article 12, ou accepter un devis de la part de l’équipe de VISEET.',
                    'cgu'
                )}
            </p>
            <h2>{__('Traitement des données personnelles', 'cgu')}</h2>
            <h3>{__('Données “organisateur”', 'cgu')}</h3>
            <p>
                {__(
                    "Les données nominatives renseignées lors de la création d'un compte lors de l’utilisation du Service sont traitées dans le respect des principes de protection des données personnelles.",
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'VISEET a déclaré la collecte et le traitement des données personnelles auprès de la CNIL. L’ensemble des éléments relatifs à l’utilisation du compte (informations, données de connexion...) sera conservé et archivé par VISEET ou un tiers prestataire de VISEET.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'VISEET pourra se prévaloir, notamment à des fins probatoires, de tout acte, fichier, enregistrement, sur tous supports dont le support informatique établi, reçu ou conservé directement ou indirectement par VISEET dans une base de données.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    "VISEET s’engage à ne communiquer ces informations à des tiers que sur réquisition d'une autorité judiciaire ou administrative habilitée française, ou rattachée à l'État dans lequel elles sont traitées et/ou stockées.",
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    "VISEET peut également utiliser l'adresse IP pour identifier les utilisateurs qui contreviendraient aux présentes ou qui causeraient un dommage à VISEET. Dans ce cas, VISEET sera fondée à transmettre les données de connexion auprès des autorités compétentes.",
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    "Conformément à la Loi n° 78-17 du 6 janvier 1978 modifiée, dite Loi Informatique et Libertés, l’Utilisateur dispose d'un droit de consultation, de modification et de retrait des données personnelles collectées par VISEET. Ces droits peuvent être exercés en adressant un message électronique à l’adresse contact@viseet.me",
                    'cgu'
                )}
            </p>
            <h3>{__('Données “invités”', 'cgu')}</h3>
            <p>
                {__(
                    'L’organisateur est responsable du traitement des données personnelles des invités selon les termes de l’annexe aux présentes CGU : “Traitement des données personnelles des invités”',
                    'cgu'
                )}
            </p>
            <h2>{__('Durée', 'cgu')}</h2>
            <p>
                {__(
                    'Le présent contrat prend effet, pour une durée indéterminée, à compter de l’acceptation des CGU par l’Organisateur lors de la sélection de l’option « J’accepte » ou à la signature d’un devis établi par la société VISEET à l’intention de l’Organisateur.',
                    'cgu'
                )}
            </p>
            <h2>{__('Paiement', 'cgu')}</h2>
            <p>
                {__(
                    'L’Organisateur s’engage à respecter les modalités de paiement figurant sur les devis qui lui seront communiqués par VISEET. A défaut, les pénalités encourues de plein droit et sans mise en demeure préalable seront égales à trois (3) fois le taux d’intérêt légal. En outre, l’Organisateur sera redevable de plein droit d’une indemnité forfaitaire de quarante (40) euros pour frais de recouvrement. VISEET sera par ailleurs en droit de réclamer une indemnisation complémentaire, sur justification, si les frais de recouvrement exposés sont supérieurs au montant de cette indemnité forfaitaire.',
                    'cgu'
                )}
            </p>
            <h2>{__('Réception des courriels envoyés par VISEET', 'cgu')}</h2>
            <p>
                {__(
                    'L’Organisateur s’engage à faire en sorte de recevoir les courriels qui lui sont adressés par VISEET et doit veiller à ne pas en bloquer la réception.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'Il appartient à l’Organisateur de vérifier en temps utiles que les courriels qui lui ont été adressés par VISEET lui sont bien parvenus, VISEET ne pouvant être tenue responsable des conséquences directes et indirectes liées à la non-réception de ses courriels par l’Organisateur.',
                    'cgu'
                )}
            </p>
            <h2>
                {__(
                    'Connexion Internet, navigateur et matériel utilisé',
                    'cgu'
                )}
            </h2>
            <p>
                {__(
                    "Pour utiliser le Service, l’Organisateur doit disposer d’un accès à l'Internet fiable. VISEET n’est pas responsable de la perte, de la viabilité ou du débit de la connexion Internet utilisée par l’Organisateur avec le Service, quelle qu’en soit la nature.",
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'VISEET n’est pas responsable de la qualité et des performances du réseau Wifi utilisé avec le Service si celui-ci n’a pas été mis en place par ses soins.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'Il appartient à l’Organisateur de vérifier la bonne compatibilité du Service avec le navigateur et la version de ce dernier qu’il utilise, VISEET ne garantissant pas la compatibilité du Service avec l’ensemble des navigateurs du marché.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'VISEET ne saurait en aucun cas être tenue responsable des dysfonctionnements du matériel utilisé avec le Service.',
                    'cgu'
                )}
            </p>
            <h2>{__('Paramétrages', 'cgu')}</h2>
            <p>
                {__(
                    'Le Service peut être paramétré dans les limites des possibilités qu’il peut raisonnablement offrir.',
                    'cgu'
                )}
            </p>
            <h2>{__('Paramétrages par l’Organisateur', 'cgu')}</h2>
            <p>
                {__(
                    'L’Organisateur est seul responsable des paramétrages du Service qu’il effectue et en devient propriétaire. La responsabilité de VISEET ne saurait en aucun cas être engagée à raison des paramétrages effectués par l’Organisateur.',
                    'cgu'
                )}
            </p>
            <h2>{__('Paramétrages par VISEET', 'cgu')}</h2>
            <p>
                {__(
                    'L’Organisateur peut demander à VISEET de paramétrer le Service selon ses besoins. VISEET proposera dans ce cas à l’Organisateur un devis avec un planning indicatif de développement.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'VISEET pourra répondre aux demandes additionnelles du Client non prévues dans le devis initial dans un délai de deux jours ouvrés minimum. Toute demande complémentaire, tout dépassement significatif des temps de développement dus à des ajustements demandés par l’Organisateur par rapport au devis initial au cours de la phase de développement donneront lieu à une facturation supplémentaire par rapport au devis initial sur la base du temps-homme passé selon le taux journalier ou horaire indiqué dans le devis.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'VISEET garantit un rendu homogène de ses paramétrages sur les navigateurs suivants :',
                    'cgu'
                )}
            </p>
            <ul>
                <li>Microsoft Edge</li>
                <li>{__('Safari version 12 et ultérieures', 'cgu')}</li>
                <li>Chrome</li>
                <li>Firefox</li>
            </ul>
            <p>
                {__(
                    'Les paramétrages réalisés par VISEET sont couvert par une garantie de 14 jours calendaires. Si au cours des 14 jours suivant la signature du devis ou l’ouverture du service, un comportement non conforme est détecté par le client, il transmettre une demande à VISEET afin que l’anomalie soit corrigée. Cette garantie couvre également les traitements de données nécessaires à la remise en conformité, sauf',
                    'cgu'
                )}
            </p>
            <h2>
                {__('Maintenance évolutive, assistance et formation', 'cgu')}
            </h2>
            <p>
                {__(
                    'Le Service comprend s’il est mentionné dans le devis, assistance technique téléphonique ou formation.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    "VISEET pourra proposer à l’Organisateur, moyennant des conditions à définir, des prestations de maintenance évolutive, de support téléphonique ou de formation. À tout moment, l’Organisateur peut effectuer une demande d'assistance par courriel à l'adresse contact@viseet.me",
                    'cgu'
                )}
            </p>
            <h2>{__('Changement d’offre', 'cgu')}</h2>
            <p>
                {__(
                    'L’Organisateur a la possibilité de souscrire à tout moment à une offre Pack supérieure s’il souhaite obtenir plus d’avantages et de fonctionnalités. Si l’Organisateur souhaite souscrire à un Pack supérieur, il devra alors s’acquitter d’un montant supplémentaire.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'VISEET se réserve le droit de refuser ou supprimer le compte d’un Organisateur si ce dernier se révèle insolvable.',
                    'cgu'
                )}
            </p>
            <h2>{__('Engagements de l’Organisateur', 'cgu')}</h2>
            <h2>{__('Utilisation licite du Service', 'cgu')}</h2>
            <p>
                {__(
                    'L’Organisateur s’engage à utiliser le Service de manière licite.',
                    'cgu'
                )}
            </p>
            <h2>{__('Engagements liés au contenu', 'cgu')}</h2>
            <p>
                {__(
                    'L’Organisateur est entièrement responsable du contenu qu’il met en ligne. Il s’engage à respecter la législation en vigueur, notamment:',
                    'cgu'
                )}
            </p>
            <ul>
                <li>
                    {__(
                        'les dispositions relatives à la Loi pour la Confiance dans l’Economie Numérique du 21 juin 2004 numéro 2004-575, et tous ses décrets d’application,',
                        'cgu'
                    )}
                </li>
                <li>
                    {__('la législation en vigueur sur la publicité,', 'cgu')}
                </li>
                <li>
                    {__(
                        'la législation en vigueur sur la propriété intellectuelle,',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'les droits des tiers (droit à l’image, droit à la vie privée, ainsi que la Loi du 21 juillet 1881).',
                        'cgu'
                    )}
                </li>
            </ul>
            <p>
                {__(
                    'VISEET se réserve le droit de supprimer sans préavis et librement tout contenu ne respectant pas les CGU, ou qui serait contraire aux bonnes mœurs, à la règlementation applicable en matière de liberté de la presse, liberté d’expression, d’apologie de crime, de négation de crime, d’appel à la violence, de droit de la consommation, droit de la propriété, en ce compris en matière de droits de propriété intellectuelle sans que cette liste ne soit limitative.',
                    'cgu'
                )}
            </p>
            <h2>{__('Engagements liés à l’Evènement', 'cgu')}</h2>
            <p>
                {__(
                    'L’Organisateur s’interdit d’utiliser le Service pour organiser des Evènements dont l’objet est illicite ou interdit.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'L’Organisateur déclare disposer : de toutes les autorisations, administratives notamment, requises pour la mise en place de l’Evènement. A ce titre, il s’engage à respecter la réglementation applicable à l’Evènement et notamment, sans que cette liste ne soit exhaustive : le code du travail et la réglementation applicable.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    "L'Organisateur fait une présentation loyale et sincère de ses Evènements de sorte à ne pas créer de confusion ni d’erreur dans l’esprit des Invités.",
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'La responsabilité de VISEET ne saurait être engagée à raison des informations publiées par l’Organisateur au titre de l’organisation de l’Evènement.',
                    'cgu'
                )}
            </p>
            <p>{__('Respect du droit des tiers', 'cgu')}</p>
            <p>
                {__(
                    "L’Organisateur garantit être titulaire de l'ensemble des droits d'auteur et/ou droits voisins relatifs aux images et/ou photographies et/ou aux contenus de ses publications et/ou tous autres éléments qu’il publie sur le Service ou qu’il fournit ou partage dans le cadre des Evènements.",
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'L’Organisateur garantit avoir obtenu l’autorisation des personnes représentées sur les photographies et/ou images qu’il pourrait publier sur le Service.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'L’Organisateur s’engage à ne publier aucun contenu ou image de nature à porter atteinte à la réputation, à l’image et/ou à la vie privée et s’engage à ne pas tenir de propos qui seraient contraires à l’ordre public et aux bonnes mœurs ou pourraient inciter à des comportements de haine raciale ou préjudiciables à la santé publique, qui porteraient atteinte à l’honneur ou à la considération de toute personne et susceptibles d’ouvrir droit à une action en diffamation, ou encore qui comporteraient des expressions outrageantes, des invectives ou des injures. L’Organisateur s’engage à ne pas publier d’informations qu’il aurait obtenues sur des utilisateurs ou des tiers, ou de contenus d’utilisateurs ou de tiers sans leur accord préalable.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'Si l’Organisateur constate un contenu illicite, un abus ou une violation relative à des droits de tiers, il peut le signaler à VISEET en adressant un courriel à l’adresse contact@viseet.me',
                    'cgu'
                )}
            </p>
            <h2>{__('Propriété intellectuelle', 'cgu')}</h2>
            <p>
                {__(
                    'VISEET détient seule la propriété intellectuelle du Service et du code source afférent. L’utilisation du Service par l’Organisateur ne confère à celui-ci aucun droit de propriété intellectuelle sur le Service.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'L’Organisateur s’oblige à respecter les mentions de propriété concernant le Service. Il s’interdit formellement :',
                    'cgu'
                )}
            </p>
            <ul>
                <li>
                    {__(
                        'de reproduire de façon permanente ou provisoire le Service en tout ou partie, par tout moyen et sous toute forme, y compris à l’occasion du chargement, de l’affichage, de l’exécution ou du stockage du logiciel;',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'de traduire, adapter, arranger, décompiler, ou modifier le Service, l’exporter, de le fusionner avec d’autres applications informatiques;',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'de tenter d’obtenir le code source du Service.',
                        'cgu'
                    )}
                </li>
            </ul>
            <p>
                {__(
                    'Si l’Organisateur demande à VISEET d’adapter le Service à ses besoins spécifiques, VISEET conserve la propriété des paramétrages et développements réalisés ainsi que des codes sources produits, qui ne pourront pas, sauf accord expresse de VISEET, être utilisés par l’Organisateur dans un cadre différent de celui de l’Evènement organisé.',
                    'cgu'
                )}
            </p>
            <h2>
                {__('Refus d’accès au Service et fermeture de compte', 'cgu')}
            </h2>
            <p>
                {__(
                    'VISEET se réserve le droit de refuser l’accès au Service à l’Organisateur si celui-ci apparaît susceptible de porter atteinte aux droits d’un tiers ou d’enfreindre la loi.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'En cas de manquement de l’Organisateur à l’une des obligations décrites à l’Article 17, VISEET se réserve le droit de fermer le compte de l’Organisateur, de refuser toute nouvelle inscription de sa part, sans préjudice pour VISEET de la possibilité de lui demander des dommages et intérêts.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'L’Organisateur renonce à toute demande d’indemnité ou de dommages-intérêts à raison d’une fermeture de compte ou d’un refus d’inscription.',
                    'cgu'
                )}
            </p>
            <h2>{__('Responsabilité de VISEET', 'cgu')}</h2>
            <p>
                {__(
                    'VISEET s’engage à mettre en œuvre tous les moyens dont elle dispose pour assurer le bon fonctionnement et la bonne disponibilité du Service.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'La responsabilité de VISEET ne saurait être engagée à raison :',
                    'cgu'
                )}
            </p>
            <ul>
                <li>
                    {__(
                        'De dommages directs ou indirects résultant de perturbations, de dérangements, d’interruptions ou de l’indisponibilité du Service;',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'D’une inadéquation entre les besoins de l’Organisateur et le Service;',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        "D'une mauvaise utilisation, ou d’une utilisation frauduleuse, abusive ou excessive du Service;",
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'Des contenus accessibles sur le réseau Internet et des dommages qui peuvent naître de leur utilisation à moins que ces contenus aient été édités par VISEET elle-même;',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'D’éventuels dysfonctionnements sur le matériel de l’Organisateur qui résulteraient de l’utilisation du Service;',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'De la saturation ou d’une défaillance du réseau Internet;',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'De litiges pouvant opposer l’Organisateur à des Invités ou des tiers, nés à l’occasion de l’utilisation du Service;',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'De dommages résultant de la perte, de l’altération ou de toute utilisation frauduleuse de données, de la transmission accidentelle de virus ou autres éléments nuisibles, de l’attitude ou comportement d’un tiers. L’Organisateur déclare avoir connaissance de la vulnérabilité des données circulant sur le réseau Internet aux interceptions et détournements et ne saurait rechercher la responsabilité de VISEET à cet égard,',
                        'cgu'
                    )}
                </li>
                <li>
                    {__(
                        'De l’objet de l’Evénement ou de son organisation.',
                        'cgu'
                    )}
                </li>
            </ul>
            <p>
                {__(
                    'VISEET ne saurait être tenue pour fautive en vertu des présentes si l’exécution de ses obligations en tout ou en partie, est retardée ou empêchée suite à la survenance d’un évènement de force majeure au sens de la jurisprudence tels que :, blocage des réseaux de communications électroniques, dispositions d’ordre législatif ou réglementaires rendant impossible l’exécution de la présente convention et plus généralement tout événement extérieur à VISEET, imprévisible et irrésistible susceptible d’empêcher la bonne utilisation des réseaux de communications électroniques.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'En toute hypothèse, la responsabilité de VISEET, quelle qu’en soit la cause ou le fondement, est limitée aux sommes hors taxes payées par l’Organisateur à VISEET au titre de l’utilisation du Service.',
                    'cgu'
                )}
            </p>
            <h2>{__('Loi applicable – Attribution de juridiction', 'cgu')}</h2>
            <p>
                {__(
                    'LE PRESENT CONTRAT EST REGI PAR LE DROIT FRANÇAIS.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'TOUT LITIGE ENTRE VISEET ET L’ORGANISATEUR, DE QUELQUE NATURE QUE CE SOIT ET DECOULANT DES CGU, SERA SOUMIS AU TRIBUNAL DE COMMERCE DE NANTERRE, SEUL COMPETENT ET CE, MEME EN CAS DE PLURALITE DE DEFENDEURS, D’APPEL EN GARANTIE OU D’INSTANCE EN REFERE.',
                    'cgu'
                )}
            </p>
            <p>
                {__(
                    'VISEET SAS – 59 rue de l’Ancienne Mairie 92100 Boulogne Billancourt',
                    'cgu'
                )}
            </p>
            <p>
                {__('R.C.S Nanterre 897 655 643 - TVA : FR76897655643', 'cgu')}
            </p>
        </RichLayout>
    );
};

Cgu.getInitialProps = async () => {
    return {
        namespacesRequired: ['common']
    };
};

export default Cgu;
